import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AbpHttpInterceptor } from '../httpInterceptor';

import * as ApiServiceProxies from './service-proxies';


@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    ApiServiceProxies.CountryServiceProxy,
    ApiServiceProxies.SessionServiceProxy,
    ApiServiceProxies.PatientTokenAuthServiceProxy,
    ApiServiceProxies.PatientServiceProxy,
    ApiServiceProxies.AccountServiceProxy,
    { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
  ],
})
export class ServiceProxyModule { }

